// extracted by mini-css-extract-plugin
export default {"strip":"fd+oz","viewArea":"LIS-A"};